<template>
    <section>
        <div class="container">
            <div class="row d-block d-lg-none">
                <div class="col-12 col-lg-6">
                    <h1>{{model.Headline}}</h1>
                    <p>{{model.Description}}</p>
                    <div class="office-search-container">
                        <input type="text" v-model="query" v-on:keyup.enter="updateFilters"/>
                        <div class="office-search-btn" @click="updateFilters"></div>
                    </div>
                    <a class="office-search-location" v-if="hasGeolocationPermissions" @click="geolocation">{{model.LocationCtaText}}</a>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6 order-2 order-lg-1">
                    <div class="d-none d-lg-block">
                        <h1>{{model.Headline}}</h1>
                        <p>{{model.Description}}</p>
                        <div class="office-search-container">
                            <input type="text" v-model="query" v-on:keyup.enter="updateFilters"/>
                            <div class="office-search-btn" @click="updateFilters"></div>
                        </div>
                        <a class="office-search-location" v-if="hasGeolocationPermissions" @click="geolocation">{{model.LocationCtaText}}</a>
                    </div>
                    <div class="office-search-results" v-if="listing">
                        <div v-if="listing.length == 0" class="office-search-results-message">
                            <p v-if="initMsg">{{model.SearchResultsText}}</p>
                            <p v-if="!initMsg">{{model.SearchResultsEmptyError}}</p>
                        </div>

                        <office-card v-for="(item, key) in listing" v-bind:item="item" v-bind:index="key + 1" v-bind:key="item.Guid"></office-card>
                        <pagination v-bind:totalResults="listing.length"></pagination>
                    </div>
                </div>
                <div class="col-12 col-lg-6 order-1 order-lg-2" id="map">
                    <agent-map></agent-map>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import SmoothScroll from 'smooth-scroll';
    import he from 'he';
	import { mapState, mapActions, mapMutations } from 'vuex';
    import Pagination from '../components/pagination';
    import AgentMap from '../components/map';
    import OfficeCard from '../components/location-finder/office-card';

	export default {
		props: ['result', 'model'],
		data: function () {
			return {
                searchText: '',
                query: '',
                hasGeolocationPermissions: true
			}
		},
		computed: mapState({
            listing: state => state.listing.listing,
            selectedLocation: state => state.listing.selectedLocation,
            initMsg: state => state.listing.initMsg,
		}),
		components: {
            pagination: Pagination,
            'agent-map': AgentMap,
            'office-card': OfficeCard
		},
		mounted: function () {
            let _this = this;
            this.setInitData(this.result); 
            this.handleGeolocationState(); 
            this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
                    this.setSelectedLocation('');
                    this.searchText = this.getQueryParams('Query');
				}
			});

            this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/setListing') {
					document.querySelector('#filter-app').scrollIntoView({
					    behavior: 'smooth'
				    });
				}
			});
		},
		methods: {
            ...mapActions('listing', { setFilter: 'setFilter' }),
            ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
            ...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
            ...mapMutations('listing', { setInitData: 'setInitData' }),
            ...mapMutations('listing', { setSelectedLocation: 'setSelectedLocation' }),

            getQueryParams(param) {
				let uri = window.location.search.substring(1);
				let params = new URLSearchParams(uri);
				return params.get(param);
			},
            updateFilters() {
                this.resetSpecification();
                this.updateSpecification({ key: 'Query', value: he.decode(this.query) });
            },
            toggleGeolocationPermissionState(state) {
                if (state === 'granted') {      
                   this.hasGeolocationPermissions = true;
                } else if (state === 'denied') {            
                    this.hasGeolocationPermissions = false;
                } else if (state === 'prompt') {
                    this.hasGeolocationPermissions = true;
                }
            },
            handleGeolocationState() {
                if (navigator.permissions) {
                    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
                        this.toggleGeolocationPermissionState(result.state);

                        result.onchange = () => {
                            this.toggleGeolocationPermissionState(result.state);
                        };
                    }); 
                }
            },
            geolocation() {
                if (navigator.geolocation) {
                    this.query = '';
                    navigator.geolocation.getCurrentPosition(this.geolocationSuccess, this.handleGeolocationState());
                }
            },
            geolocationSuccess(position) {
                this.resetSpecification();
                this.updateSpecification({ key: 'Coords', value: JSON.stringify({ Latitude: position.coords.latitude, Longitude: position.coords.longitude}) });
            }            
        },
    }
</script>